export default __webpack_public_path__ + "static/media/1691.2ed8f122.png";